import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 4h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h2a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2z","key":"svg-0"}],["path",{"d":"M17 4h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h2a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2z","key":"svg-1"}]]

const IconPlayerPauseFilled = createReactComponent('filled', 'player-pause-filled', 'PlayerPauseFilled', __iconNode);

export default IconPlayerPauseFilled;